import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { usePageMeta } from 'shared/mechanics/page-meta';
import { prerenderMarkLoaded } from 'shared/mechanics/prerender';

import { MapItemsComponent } from './components/MapItemsComponent';

export const MapIndexPage = () => {
	usePageMeta({
		title: 'Инфографика фондов',
		description: 'Как выглядит рынок ETF и БПИФ',
		keyWords: ['выбор', 'графика', 'схема'],
		canonicalPath: 'map' });

	prerenderMarkLoaded();

	return (
		<SiteLayoutComponent activeSection={SiteSection.Map}>
			<MapItemsComponent />
		</SiteLayoutComponent>
	);
}